<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon">
            <img src="@/assets/img/novi_predmet.svg" />
          </div>
          <div class="entry-title">{{form_title}}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"
            ><img src="@/assets/img/entry_form_close.svg"
          /></a>
        </div>
      </div>
      <!-- end new case header -->
      <div class="main-entry-form-wrapper">
        <!-- *** BROJ SPISA **** -->
        <form-input
          label="Broj spisa"
          id="broj-spisa"
          ref="brojSpisa"
          required="required"
          :base="is_edit ? unos_spisa.broj_spisa : current_spis"
          :disabled="true"
          :invalid="is_invalid.broj_spisa"
        ></form-input>
        <!-- *** IME / OPIS SPISA **** -->
        <form-input
          label="Opis spisa"
          id="ime-spisa"
          ref="imeSpisa"
          :base="unos_spisa.ime_spisa"
        ></form-input>
        <!-- *** DIVIDER **** -->
        <div class="form-divider"></div>
        <!-- *** VRSTA POSTUPKA **** -->
        <form-drop-down
          label="Vrsta postupka"
          id="vrsta-postupka"
          ref="vrstaPostupka"
          :dropImport="postupci"
          :base="unos_spisa.vrsta_postupka.ID"
        ></form-drop-down>
        <form-input
          label="Trenutni poslovni broj"
          id="sudski-broj"
          ref="sudskiBroj"
          :base="unos_spisa.sudski_broj"
        ></form-input>
        <div v-if="is_edit" class="form-input-wrapper">
          <label class="form-label">
            <span>Raniji poslovni brojevi</span>
          </label>
          <ul class="list-of-items">
            <li v-if="all_poslovni_brojevi.length == 0">Nema prethodnih poslovnih brojeva</li>
            <li v-else v-for="(br,key) in all_poslovni_brojevi" :key="key">{{br}}</li>
          </ul>
        </div>
        <!-- *** NADLEŽNO TIJELO **** -->
        <div class="form-autocomplete-add-wrapper">
          <form-autocomplete-single
            :name="'imeIzvora'"
            :placeholder="'Odaberite nadležno tijelo'"
            :type="'NadleznoTijelo'"
            :label="'Nadležno tijelo'"
            :id="'nadleznoTijelo'"
            ref="nadleznoTijelo"
            :items="institucije"
            :invalid="is_invalid.nadlezno_tijelo"
            @addedNadlezno="removeFromQuick"
          ></form-autocomplete-single>
          <button-person-quick
              type="Nadležno_tijelo"
              ref="quickNadleznaTijela"
              :postojeca_nadlezna="all_institucije_copy"
              @addToAutocomplete="addToAutocomplete"
              @removeExisting="removeExisting"
          ></button-person-quick>
        </div>
        <!-- *** DIVIDER **** -->
        <div class="form-divider"></div>
        <!-- *** PRAVNO TIJELO **** -->
        <div class="form-autocomplete-add-wrapper">
          <form-autocomplete
            :label="'Osobe postupka'"
            type="drugi_sudionici"
            id="drugi-sudionici"
            ref="drugiSudionici"
            placeholder="Upiši ime osobe"
            :items="drugi_sudionici"
            :statusi="statusi_drugi_sudionici"
          ></form-autocomplete>
          <!-- 		  ***treba ići drugi sudionik -->
          <button-person-quick
            type="Pravno_tijelo"
            ref="quickDrugiSudionici"
            :statusi="statusi_drugi_sudionici"
            :postojeci_sudionici="drugi_sudionici_copy"
            @addToAutocomplete="addToAutocomplete"
          ></button-person-quick>
        </div>
        <InvalidElementsList v-if="error_list.length != 0" :error_list="error_list" />
        <!-- *** KREIRAJ BUTTON **** -->
        <div class="button-create-wrapper" @click="!is_waiting_on_insert ? validate() : ''">
          <div :style="is_waiting_on_insert ? 'background-color: gray' : 'background-color: #2a23a0'" class="button-default button-create">{{form_submit_buttom}}</div>
        </div>
      </div>
      <!-- end main entry form wrapper -->
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import buttonPersonQuick from "@/components/formElements/buttonPersonQuick.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import spis_hand from "@/apiCallers/promise_handler_db/spis";
import institucije from "@/apiCallers/promise_handler_db/institucije";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import statusi from "@/apiCallers/promise_handler_db/statusi";
import auth from "@/services/auth";
import DataLoader from '@/components/generalComponents/DataLoader'
import { clearCaseData } from "@/router/case/handler"



import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
	return {
    form_title:"Unos novog spisa",
    form_submit_buttom:"Kreiraj novi spis",
    is_edit:false,
    predmet_info:null,
		current_spis:"",
		postupci:[],
		accessToken : "",
		institucije:[],
		drugi_sudionici:[],
    drugi_sudionici_copy:[],
		statusi_drugi_sudionici:[],
		unos_spisa:{
			broj_spisa:"",
			ime_spisa:"",
			vrsta_postupka:{ID:1},
			nadlezno_tijelo:"",
      quick_nadlezna_tijela: [],
			drugi_sudionici:[],
			quick_drugi_sudionici:[],
			root_spis : "",
      sudski_broj:"",
		},
    error_list:[],
    is_invalid:{
      broj_spisa:false,
      nadlezno_tijelo:false,
    },
    id_spis : "",
    is_waiting_on_insert:false,
    fetching:true,
    all_institucije_copy:[],
    initial_posl_br:null,
    all_poslovni_brojevi:[],
	}
  },
  components: {
	  "form-input": formInput,
	  "form-drop-down": formDropDown,
	  "form-autocomplete": formAutocomplete,
	  "button-person-quick": buttonPersonQuick,
	  "form-autocomplete-single": formAutocompleteSingle,
    InvalidElementsList,
    DataLoader
  },
  methods: {
    addToAutocomplete(osoba, temp_osoba_status, tip){
      let temp_obj = {
        name: osoba.value,
        status_ID: temp_osoba_status,
        UID: osoba.link,
        is_fiz: osoba.is_fiz,
      };
      switch (tip) {
        case 'Nadležno_tijelo':
          if (!this.$refs.nadleznoTijelo.results_final.UID != temp_obj.UID) {
            this.$refs.nadleznoTijelo.results_final.uid = temp_obj.UID;
            this.$refs.nadleznoTijelo.results_final.name = temp_obj.name;
          }
          break;
        case 'Pravno_tijelo':
          if (!this.$refs.drugiSudionici.$data.results_final.find(os=>os.UID == temp_obj.UID)) {
            this.drugi_sudionici = this.drugi_sudionici.filter((fiz)=>fiz.link != temp_obj.UID);
            this.$refs.drugiSudionici.$data.results_final.push(temp_obj);
          }
          break;
        default:
          break;
      }
    },
    removeExisting(){
      this.$refs.nadleznoTijelo.results_final.uid = "";
      this.$refs.nadleznoTijelo.results_final.name = "";    
    },
    removeFromQuick(){
      this.$refs.quickNadleznaTijela.$data.add_nadlezno_tijelo = [];
    },
    goBack() {
      this.$router.go(-1);
    },
    validate(){
      this.error_list = [];
      this.is_invalid={
        broj_spisa:false,
        nadlezno_tijelo:false,
      }
      console.log(this.unos_spisa);
      if (this.unos_spisa.broj_spisa.value == "") {
        this.error_list.push("Potrebno je unijeti broj spisa");
        this.is_invalid.broj_spisa = true;
      }

      if (this.error_list.length == 0) {
        this.prepareSpisJson();
      }
    },
    async prepareSpisJson(){

      let create_spis = {
        broj_spisa : this.unos_spisa.broj_spisa.value,
        ime_spisa : this.unos_spisa.ime_spisa.value,
        vrsta_postupka : parseInt(this.unos_spisa.vrsta_postupka.ID),
        sudski_broj : this.unos_spisa.sudski_broj.value,
        nadlezno_tijelo : this.unos_spisa.nadlezno_tijelo.results_final,
        drugi_sudionici : this.unos_spisa.drugi_sudionici.results_final,
        quick_drugi_sudionici : this.unos_spisa.quick_drugi_sudionici.add_pravno_tijelo,
        quick_nadlezna_tijela : this.unos_spisa.quick_nadlezna_tijela.add_nadlezno_tijelo,
        root_spis : this.unos_spisa.root_spis
      }
      this.is_waiting_on_insert = true;
      if (!this.is_edit) {
        await spis_hand.newSpis(create_spis, this.accessToken, this.$router.history.current.params.uid, this.$store.state.logged_in_user.uid).then((resp)=>{
          this.is_waiting_on_insert = false;
          clearCaseData();
          this.goBack()
        }).catch((err)=>{
          this.is_waiting_on_insert = false;
          clearCaseData();
          this.goBack()
        })
      }
      else{
        if (create_spis.sudski_broj != this.initial_posl_br && this.initial_posl_br != null && this.initial_posl_br != "") {
          create_spis.save_value = this.initial_posl_br;
        }
        else{
          create_spis.save_value = null;
        };
        await spis_hand.updateSingleSpis(this.$router.history.current.params.uid,this.id_spis,create_spis, this.$store.state.logged_in_user.uid).then((resp)=>{
          this.is_waiting_on_insert = false;
          clearCaseData();
          this.goBack()
        }).catch((err)=>{
          this.is_waiting_on_insert = false;
          clearCaseData();
          this.goBack()
        })
      }

    },
    async connectExistingData(){
      await spis_hand.getSingleSpis(this.accessToken, this.$route.params.uid, this.$route.params.broj_spisa).then((response)=>{
        this.id_spis = response.data.id_spis
        this.$refs.brojSpisa.$data.value = response.data.ime;
        this.$refs.imeSpisa.$data.value = response.data.opis_spisa;
        this.$refs.sudskiBroj.$data.value = response.data.posl_br == null ? "" : response.data.posl_br;
        this.initial_posl_br = this.$refs.sudskiBroj.$data.value;
        this.all_poslovni_brojevi = response.data.posl_br_archive.reverse();

        // setTimeout(() => {
          this.$refs.vrstaPostupka.$data.ID = response.data.id_postupak != null ? response.data.id_postupak : 1;   
        // }, 500);

        let institucija = this.institucije.filter((inst)=>inst.link == response.data.id_nadlezno_tijelo);

        if (response.data.id_nadlezno_tijelo != null) {
          this.$refs.nadleznoTijelo.$data.results_final.name = institucija[0].value;
          this.$refs.nadleznoTijelo.$data.results_final.uid = institucija[0].link;
        }
        this.$refs.drugiSudionici.$data.results_final.push(...response.data.spis_sudionici_connector.map((sudionik)=>{
          this.drugi_sudionici = this.drugi_sudionici.filter((fiz)=>fiz.link != sudionik.sluzbena_osoba.uid);
          return {
            'UID':sudionik.sluzbena_osoba.uid,
            'name':sudionik.sluzbena_osoba.ime + ' ' + sudionik.sluzbena_osoba.prezime,
            'is_fiz':true,
            'status_ID': sudionik.sluzbena_uloga.id_uloga,
          }
        }));
            this.fetching=false;
      }).catch((err)=>{
        this.fetching=false;
      })
    },
  },

  async created(){
    this.fetching=true;
	  this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
		await predmet_hand.getSingle(this.$route.params.uid).then((response) => {
    	let all_together = JSON.parse(response.data.all_info_predmet.predmet_info)
      this.predmet_info = all_together;
    	this.rootSpisi = all_together.spis;
      this.unos_spisa.root_spis = all_together.root_spis
      let spis_number_list=[];
      this.rootSpisi.map((spis)=>spis_number_list.push(parseInt(spis.ime.split("-")[2])));
      this.$refs.brojSpisa.$data.value = all_together.broj_predmeta+"-"+(parseInt(Math.max(...spis_number_list))+1);
      //set initial data

      this.$refs.vrstaPostupka.$data.ID = all_together.id_vrsta_postupka

    });
    await predmet_hand.getAllPostupci().then((resp) => {
      this.postupci = resp.data.vrste_postupka;
    });
    await institucije.getAllInstitucijeShort().then((resp) => {
    	this.institucije = resp.data;
      this.all_institucije_copy = [...this.institucije];
    });
  	await osobe.get_all_legal_body_short().then((resp) => {
      this.drugi_sudionici=resp.data;
      this.drugi_sudionici_copy = [...this.drugi_sudionici]
    });
	  await statusi.getLegBodyStatusi().then((resp) => {
      this.statusi_drugi_sudionici=resp.data.oznake_status;
    });
    if (this.$route.name == "EditExistingSpis") {
      this.is_edit = true;
      this.form_title = "Ažuriranje spisa";
      this.form_submit_buttom = "Ažuriraj spis";

      await this.connectExistingData();
    }
    else{
      this.fetching=false;
    }
  },

  mounted() {
	document.body.classList.add("new-entry");

	this.unos_spisa.broj_spisa = this.$refs.brojSpisa.$data;
	this.unos_spisa.ime_spisa = this.$refs.imeSpisa.$data;
	this.unos_spisa.vrsta_postupka = this.$refs.vrstaPostupka.$data;
  this.unos_spisa.sudski_broj = this.$refs.sudskiBroj.$data;
  this.unos_spisa.nadlezno_tijelo = this.$refs.nadleznoTijelo.$data;
	this.unos_spisa.drugi_sudionici = this.$refs.drugiSudionici.$data;
	this.unos_spisa.quick_drugi_sudionici = this.$refs.quickDrugiSudionici.$data;
  this.unos_spisa.quick_nadlezna_tijela = this.$refs.quickNadleznaTijela.$data;
	//close anim
	$(".entry-exit").hover(
	  function () {
		gsap.to($(this).find("img"), 0.3, {
		  rotation: 180,
		  transformOrigin: "center",
		});
	  },
	  function () {
		gsap.to($(this).find("img"), 0.5, {
		  rotation: -180,
		  transformOrigin: "center",
		});
	  }
	);
  },
  updated() {
	
  },
  destroyed() {
	document.body.classList.remove("new-entry");
  $(".entry-exit").off();
  },
};
</script>
